import React from 'react';
import { ClickableContainer, ExternalLinkContainer, InternalLinkContainer } from './Clickable.styles';
import { urlIsExternal } from 'src/functions/propagateQueryParams';

export interface ClickableProps {
  children?: React.ReactNode;
  onClick?: (e?: React.MouseEvent<HTMLDivElement | HTMLAnchorElement>) => void;
  disabled?: boolean;
  href?: string;
  className?: string;
  target?: string;
  rel?: string;
  display?: 'inline-block' | 'block' | 'flex';
}

const Clickable = (props: ClickableProps): JSX.Element => {
  const { children, href, disabled, className, target, rel, display, ...rest } = props;

  if (href) {
    if (urlIsExternal(href)) {
      return (
        <ExternalLinkContainer
          href={href}
          target={target || '_blank'}
          rel={rel || 'noopener noreferrer'}
          $disabled={disabled}
          $display={display}
          className={className}
          {...rest}
        >
          {children}
        </ExternalLinkContainer>
      );
    }

    return (
      <InternalLinkContainer
        to={href}
        $disabled={disabled}
        $display={display}
        className={className}
        {...rest}
      >
        {children}
      </InternalLinkContainer>
    );
  }

  const bypass = !href && !rest.onClick;

  return (
    <ClickableContainer
      $disabled={disabled}
      $bypass={bypass}
      $display={display}
      className={className}
      {...rest}
    >
      {children}
    </ClickableContainer>
  );
};

export default Clickable;
